import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchBranchMIS = createAsyncThunk(
  'fetchBranchMIS',
  async ({ duration, jwtBearer }) => {
    const response = await fetch(
      `${BASE_URL}upload/branch/mis/details/?duration=${duration}`,
      {
        headers: {
          Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
        }
      }
    )
    return response.json()
  }
)

const branchMISSlice = createSlice({
  name: 'branchMIS',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchBranchMIS.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchBranchMIS.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchBranchMIS.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default branchMISSlice.reducer
